import React from 'react';
import { GBTypography } from '@leapfinance/geebee-component-library';
import Sparkles from '../../icons/utility-cards/Sparkles';
import CustomSlider from '../../CustomSlider';
import { CardGroupLabelMapper } from './utils';
var UtilityCardHolder = function (_a) {
    var children = _a.children, sliderProps = _a.sliderProps, totalSlides = _a.totalSlides, slideMaxWidth = _a.slideMaxWidth, cardGroup = _a.cardGroup, preventAutoHeightCalculation = _a.preventAutoHeightCalculation, boxStyles = _a.boxStyles;
    var Icon = Sparkles;
    return (React.createElement("div", { className: "lfc-flex lfc-flex-col lfc-gap-4" },
        React.createElement("div", { className: "lfc-flex lfc-flex-col lfc-gap-2" },
            React.createElement(GBTypography, { variant: "sh1Semibold", className: "lfc-flex lfc-gap-2 lfc-items-center" },
                React.createElement(Icon, null),
                " ",
                CardGroupLabelMapper[cardGroup].title),
            React.createElement(GBTypography, { variant: "body4", className: "lfc-text-gbTokens-grey-500" }, CardGroupLabelMapper[cardGroup].subtitle)),
        React.createElement(CustomSlider, { sliderProps: sliderProps, slideMaxWidth: slideMaxWidth, preventAutoHeightCalculation: preventAutoHeightCalculation, boxStyles: boxStyles }, children)));
};
export default UtilityCardHolder;
//# sourceMappingURL=UtilityCardHolder.js.map